import React from 'react'
import clsx from 'clsx'
import MaterialSymbol from 'components/material-symbol/material-symbol'

export const getMessagingFileSymbolName = (mimeType = '') => {
  const type = mimeType.toLowerCase()

  if (!type) return 'draft'
  if (type === 'application/pdf') return 'picture_as_pdf'
  if (type.startsWith('image/')) return 'image'
  if (type.startsWith('audio/')) return 'audio_file'
  if (type.startsWith('video/')) return 'movie'
  if (type.startsWith('text/')) return 'description'
  if (
    type.includes('spreadsheet') ||
    type === 'text/csv' ||
    type.includes('excel')
  ) {
    return 'table_chart'
  }
  if (type.includes('presentation') || type.includes('powerpoint')) {
    return 'slideshow'
  }
  if (type.includes('word') || type.includes('opendocument.text')) {
    return 'description'
  }
  if (
    type.includes('zip') ||
    type.includes('archive') ||
    type.includes('compressed') ||
    type.includes('x-7z') ||
    type.includes('x-rar')
  ) {
    return 'folder_zip'
  }
  if (
    type.includes('json') ||
    type.includes('javascript') ||
    type.includes('xml') ||
    type.includes('typescript') ||
    type.includes('x-python')
  ) {
    return 'code'
  }

  return 'draft'
}

const MessagingFileIcon = ({ className, mimeType, withCircle = true }) => {
  const icon = (
    <MaterialSymbol
      name={getMessagingFileSymbolName(mimeType)}
      fontSize={16}
      htmlColor="#172024"
    />
  )

  if (!withCircle) {
    return icon
  }

  return (
    <span
      className={clsx(
        'str-chat__file-icon',
        'messaging-file-icon-circle',
        className,
      )}
    >
      {icon}
    </span>
  )
}

export default MessagingFileIcon
